import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";

interface IFormInput {
    id?: string;
    name: string;
    label: string;
    control?: any;
    error?: any;
    maxLength?: number;
    multiline?: boolean;
    disabled?: boolean;
    onClick?: any;
    onChange?: any;
}

const textField: React.FC<IFormInput> = ({
    id,
    name,
    label,
    control,
    error,
    maxLength,
    multiline,
    disabled,
    onChange,
    onClick,
}) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange: renderChange, value, onBlur } }) => (
                <TextField
                    id={id}
                    value={value || ""}
                    onBlur={onBlur}
                    margin="normal"
                    size="small"
                    label={label}
                    variant="outlined"
                    multiline={multiline}
                    error={!!error && !!error[name]}
                    helperText={!!error && error[name]?.message}
                    fullWidth
                    disabled={disabled}
                    onChange={renderChange}
                    onClick={onClick}
                    inputProps={{
                        maxLength: maxLength,
                    }}
                />
            )}
        />
    );
};

export default textField;
